import { AuditLogPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useQuery } from 'modules/core/hooks/useQuery'

import SettingsCollectionsBootstrap from 'modules/audit_log/lib/SettingsCollectionsBootstrap'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import AuditTable from './_Table'

interface Props {
  streamId?: string
  streamModel?: string
}

export interface AuditLogAccess {
  id: string
  firstName: string | null
  lastName: string | null
  avatar: string | null
}

const Container = observer(({ streamId, streamModel }: Props) => {
  const { data, loading, error } = useQuery(AuditLogPageDocument)
  const canSeeAuditLog = Boolean(data?.auditLog._policies.seeAuditLog)
  const accesses: AuditLogAccess[] = (data?.apiCore.accesses ?? []).map((access) => ({
    id: access.id,
    firstName: access.firstName,
    lastName: access.lastName,
    avatar: access.avatar ?? null,
  }))

  return (
    <ResponsivePage.Body authorized={canSeeAuditLog} loading={loading} error={error}>
      <AuditTable streamId={streamId} streamModel={streamModel} accesses={accesses} />
    </ResponsivePage.Body>
  )
})

const AuditLogPage = () => {
  return (
    <SettingsCollectionsBootstrap>
      <Container />
    </SettingsCollectionsBootstrap>
  )
}

export default AuditLogPage
